import React from 'react';
import { Group, Rect, Text, Line, Circle } from 'react-konva';

// Draw everything in meters - scale is applied at parent Group level
export function ElectricityPointRenderer({ point, wall, roomCenter }) {
  if (!point || !wall?.startPoint || !wall?.endPoint || !roomCenter) {
    return null;
  }

  // ---------------------------
  // Wall geometry
  // ---------------------------
  const x1 = wall.startPoint.x;
  const y1 = wall.startPoint.y;
  const x2 = wall.endPoint.x;
  const y2 = wall.endPoint.y;

  const dx = x2 - x1;
  const dy = y2 - y1;
  const wallLen = Math.hypot(dx, dy) || 1;

  const ux = dx / wallLen;
  const uy = dy / wallLen;

  // ---------------------------
  // Point position on wall
  // ---------------------------
  const offset =
    point.offset !== undefined
      ? point.offset                     // meters
      : point.position !== undefined
      ? point.position * wallLen         // ratio → meters
      : wallLen / 2;

  const pointX = x1 + ux * offset;
  const pointY = y1 + uy * offset;

  // ---------------------------
  // Determine inward normal (toward room)
  // ---------------------------
  const nx1 = -uy;
  const ny1 =  ux;
  const nx2 =  uy;
  const ny2 = -ux;

  const toCenterX = roomCenter.x - pointX;
  const toCenterY = roomCenter.y - pointY;

  const dot1 = nx1 * toCenterX + ny1 * toCenterY;
  const dot2 = nx2 * toCenterX + ny2 * toCenterY;

  const nx = dot1 > dot2 ? nx1 : nx2;
  const ny = dot1 > dot2 ? ny1 : ny2;

  // ---------------------------
  // Layout constants (meters)
  // ---------------------------
  const labelOffset = 0.22;      // distance from wall into room
  const labelWidth = 0.40;
  const labelHeight = 0.24;
  const cornerRadius = 0.03;

  const labelX = pointX + nx * labelOffset;
  const labelY = pointY + ny * labelOffset;

  // ---------------------------
  // Render
  // ---------------------------
  return (
    <Group>
      {/* Anchor point on wall */}
      <Circle
        x={pointX}
        y={pointY}
        radius={0.025}
        fill="#1976D2"
        listening={false}
      />

      {/* Connection line */}
      <Line
        points={[pointX, pointY, labelX, labelY]}
        stroke="#666"
        strokeWidth={0.01}
        strokeScaleEnabled={false}
        dash={[0.03, 0.03]}
        listening={false}
      />

      {/* Label background */}
      <Rect
        x={labelX - labelWidth / 2}
        y={labelY - labelHeight / 2}
        width={labelWidth}
        height={labelHeight}
        fill="#FFEB3B"
        stroke="#FBC02D"
        strokeWidth={0.01}
        strokeScaleEnabled={false}
        cornerRadius={cornerRadius}
        listening={false}
      />

      {/* Type */}
      <Text
        x={labelX - labelWidth / 2 + 0.05}
        y={labelY - labelHeight / 2 + 0.03}
        text={point.type}
        fontSize={0.10}
        fill="#1976D2"
        fontStyle="bold"
        listening={false}
      />

      {/* Height */}
      <Text
        x={labelX - labelWidth / 2 + 0.05}
        y={labelY - labelHeight / 2 + 0.13}
        text={`${point.height} m`}
        fontSize={0.08}
        fill="#1976D2"
        listening={false}
      />
    </Group>
  );
}